import React from 'react';

import { EntitySearchHolder } from '~/components/entity-search/entity-search-holder/entity-search-holder';

import styles from '~/components/entity-search/entity-search-input/entity-search-input.module.scss';

interface Props {
	label: string;
	name: string;
	onChange: (value: string) => void;
	value: string;
	title: string;
	maxLength?: number;
	inputRef?: React.RefObject<HTMLInputElement>;
}

export class EntitySearchInput extends React.Component<Props> {
	private onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		this.props.onChange(e.target.value);
	};

	public render() {
		const { label, name, onChange, value, maxLength, inputRef, title } =
			this.props;
		return (
			<EntitySearchHolder label={label} name={name} title={title}>
				<input
					type="text"
					id={name}
					name={name}
					className={styles.input}
					onChange={this.onChange}
					value={value}
					autoComplete="off"
					maxLength={maxLength}
					ref={inputRef}
				/>
			</EntitySearchHolder>
		);
	}
}
